import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Btn, Input, Field } from "@/components/common";
import { AuthShell } from "@/pages/Login";
import { apiError } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(email, password, name);
      toast.success("Workspace created");
      navigate("/app");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Create account" sub="A personal workspace is created for you.">
      <form onSubmit={submit}>
        <Field label="Name"><Input data-testid="register-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" /></Field>
        <Field label="Email"><Input data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" /></Field>
        <Field label="Password" hint="At least 6 characters."><Input data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" /></Field>
        <Btn data-testid="register-submit" type="submit" variant="primary" className="w-full" disabled={loading}>{loading ? "Creating…" : "Create account"}</Btn>
      </form>
      <div className="mt-5 text-sm text-center">
        <Link to="/login" style={{ color: "var(--si-silver)" }}>Already have an account? Sign in</Link>
      </div>
    </AuthShell>
  );
}
